import { catalog } from '../core/catalog.js';
import { t } from '../core/i18n.js';
import { notify } from '../core/notify.js';
import { escapeHtml } from '../core/utils.js';

/* «Corregir emparejado»: cuando Jellyfin, Emby o Plex han identificado mal un título (otra película con el mismo nombre,
   otro año…), se busca la correcta y se aplica en el servidor. El servidor puede exigir ser administrador. */

export function openMatch({ kind, item, onDone = () => {} }) {
    const app = window.app;
    const id = 'match-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('match.title')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="phone-body" data-match></div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const body = (p.el || document.getElementById(id)).querySelector('[data-match]');
                let found = [];
                const msg = (e) => (e && e.code === 'forbidden' ? t('match.forbidden') : t('match.error'));
                const results = () => (found.length ? found.map((c) => `<button type="button" class="admin-user" data-pick="${escapeHtml(c.key)}" style="width:100%;text-align:left">
                        <span class="rmt-thumb" style="width:44px;aspect-ratio:2/3;flex:none;background:var(--surface-2) center/cover no-repeat ${/^https?:/.test(c.thumb) ? `;background-image:url('${escapeHtml(c.thumb)}')` : ''}"></span>
                        <div class="admin-user-body"><div class="admin-user-name">${escapeHtml(c.title)}${c.year ? ` <small>(${escapeHtml(c.year)})</small>` : ''}</div><div class="admin-user-sub">${escapeHtml(c.source)}${c.overview ? ' · ' + escapeHtml(c.overview.slice(0, 120)) : ''}</div></div>
                    </button>`).join('') : '');
                body.innerHTML = `<p class="pw-note">${t('match.intro')}</p>
                    <div class="field"><label>${t('match.name')}</label><input name="title" value="${escapeHtml(item.name || '')}" maxlength="200"/></div>
                    <div class="field"><label>${t('match.year')}</label><input name="year" value="${escapeHtml(String(item.year || ''))}" maxlength="4" inputmode="numeric"/></div>
                    <button type="button" class="btn btn-primary btn-block" data-search><span class="mi">search</span>${t('match.search')}</button>
                    <div class="field-error" data-err hidden></div>
                    <div data-results></div>`;
                const err = body.querySelector('[data-err]');
                const box = body.querySelector('[data-results]');
                const q = (n) => body.querySelector('[name="' + n + '"]');
                body.addEventListener('click', async (e) => {
                    if (e.target.closest('[data-search]')) {
                        err.hidden = true;
                        box.innerHTML = '<div class="spinner"></div>';
                        try {
                            found = await catalog.matchSearch(kind, item, { title: q('title').value.trim(), year: q('year').value.trim() });
                            box.innerHTML = results() || `<p class="pw-note">${t('common.noResults')}</p>`;
                        } catch (er) {
                            box.innerHTML = '';
                            err.textContent = msg(er);
                            err.hidden = false;
                        }
                        return;
                    }
                    const pick = e.target.closest('[data-pick]');
                    if (!pick) return;
                    const cand = found.find((c) => c.key === pick.getAttribute('data-pick'));
                    if (!cand) return;
                    notify.confirm(t('match.confirm', { title: cand.title + (cand.year ? ' (' + cand.year + ')' : '') }), t('match.apply'), async () => {
                        box.innerHTML = '<div class="spinner"></div>';
                        try {
                            await catalog.matchApply(kind, item, cand);
                            notify.toast(t('match.done'), { icon: 'check_circle', duration: 3000 });
                            popup.close();
                            onDone();
                        } catch (er) {
                            box.innerHTML = results();
                            err.textContent = msg(er);
                            err.hidden = false;
                        }
                    });
                });
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
